import './claim-entity.detail.notes.scss';

import { Box } from '@mui/material';
import { ClaimEntityPageContainer } from './claim-entity.page.container';

export const ClaimReportDetail = () => {
  return (
    <>
      <Box>
        <ClaimEntityPageContainer
          title={'Reports'}
          titleChildren={
            <Box style={{ backgroundColor: 'white' }}>
              <>
                <Box>
                  COMING SOON! This feature is under active development and will
                  be available to you shortly. Stay tuned for updates.
                </Box>
              </>
            </Box>
          }
        >
          <Box
            style={{ marginLeft: '10px', marginTop: '40px', width: '170px' }}
          ></Box>
        </ClaimEntityPageContainer>
      </Box>
    </>
  );
};
